import {Action, ActionType, Close, ModalID, Open, Payload, State} from './types'

export const open = (id: ModalID, payload: Payload): Open => ({
  type: ActionType.OPEN,
  payload,
  id,
})

export const close = (id: ModalID): Close => ({
  type: ActionType.CLOSE,
  id,
})

const initialState: State = {}
export const MODAL_KEY = 'modal'

export const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case ActionType.OPEN: {
      return {
        ...state,
        [action.id]: action.payload,
      }
    }
    case ActionType.CLOSE: {
      delete state[action.id]
      return {...state}
    }
    default: {
      return state
    }
  }
}
